import styled from "@emotion/styled";
import { HEADER_HEIGHT, BREAKPOINTS } from "styles/constants";

export const HeaderWrapper = styled.header`
  position: fixed;
  z-index: 1000;
  width: 100%;
  height: ${HEADER_HEIGHT.desktop};
  top: 0;
  left: 0;
  background: linear-gradient(
    135deg,
    rgba(15, 23, 42, 0.95) 0%,
    rgba(30, 41, 59, 0.95) 100%
  );
  backdrop-filter: blur(16px) saturate(180%);
  -webkit-backdrop-filter: blur(16px) saturate(180%);
  border-bottom: 1px solid rgba(148, 163, 184, 0.15);
  box-shadow:
    0 1px 3px rgba(0, 0, 0, 0.12),
    0 1px 2px rgba(0, 0, 0, 0.24);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  // 顶部光效
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(139, 92, 246, 0.3) 20%,
      rgba(59, 130, 246, 0.3) 50%,
      rgba(8, 126, 164, 0.3) 80%,
      transparent
    );
    opacity: 0.6;
  }

  @media (max-width: ${BREAKPOINTS.tablet}) and (min-width: calc(${BREAKPOINTS.mobile} + 1px)) {
    height: ${HEADER_HEIGHT.tablet};
  }

  @media (max-width: ${BREAKPOINTS.mobile}) {
    height: ${HEADER_HEIGHT.mobile};
  }

  &.scrolled {
    background: linear-gradient(
      135deg,
      rgba(15, 23, 42, 0.98) 0%,
      rgba(30, 41, 59, 0.98) 100%
    );
    box-shadow:
      0 4px 12px rgba(0, 0, 0, 0.3),
      0 2px 4px rgba(0, 0, 0, 0.2);
    border-bottom-color: rgba(148, 163, 184, 0.2);

    &::before {
      opacity: 1;
    }
  }

  .header_main {
    height: 100%;
    max-width: 1440px;
    margin: 0 auto;
    padding: 0 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    @media (min-width: 1024px) {
      padding: 0 64px;
    }

    @media (max-width: 768px) {
      padding: 0 16px;
    }
  }

  .logo {
    display: flex;
    align-items: center;
    height: 100%;

    .logo-link {
      display: flex;
      align-items: center;
      gap: 12px;
      text-decoration: none;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      padding: 8px 12px;
      border-radius: 10px;
      margin-left: -12px;
      position: relative;

      &::after {
        content: "";
        position: absolute;
        inset: 0;
        border-radius: 10px;
        background: linear-gradient(
          135deg,
          rgba(139, 92, 246, 0.1),
          rgba(59, 130, 246, 0.1),
          rgba(8, 126, 164, 0.1)
        );
        opacity: 0;
        transition: opacity 0.3s ease;
      }

      &:hover {
        &::after {
          opacity: 1;
        }

        .logo-icon {
          transform: scale(1.08) rotate(-5deg);
          filter: drop-shadow(0 0 8px rgba(139, 92, 246, 0.5));
        }

        .logo-sub {
          color: #67e8f9;
          text-shadow: 0 0 20px rgba(8, 126, 164, 0.5);
        }
      }
    }

    .logo-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      position: relative;
      z-index: 1;

      img {
        height: 32px;
        width: auto;
        display: block;
        filter: brightness(1.1);

        @media (max-width: 599px) {
          height: 28px;
        }
      }
    }

    .logo-text {
      display: flex;
      align-items: baseline;
      font-weight: 700;
      line-height: 1;
      position: relative;
      z-index: 1;

      @media (max-width: 599px) {
        display: none;
      }

      .logo-sub {
        color: #38bdf8;
        font-size: 21px;
        margin-left: -1px;
        transition: all 0.3s ease;

        @media (max-width: 979px) {
          font-size: 19px;
        }
      }
    }
  }

  .header_right {
    flex: 1;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 12px;

    @media (max-width: 599px) {
      gap: 8px;
    }
  }
`;
